<template>
    <td
        class="px-3 py-4 first:pl-4 sm:first:pl-3 last:pr-4 sm:last:pr-3 text-base whitespace-normal break-words text-taupe-900"
        :class="[
            alignmentClasses,
            hidableClasses,
            importantClasses,
            primaryClasses,
        ]"
    >
        <slot>
            {{ displayContent }}
        </slot>
    </td>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
    name: 'ZenGridBodyCell',
})

const props = defineProps({
    alignment: {
        type: String,
        required: false,
    },
    content: {
        type: [String, Number],
        required: false,
    },
    hidable: {
        type: Boolean,
        required: false,
        default: true,
    },
    important: {
        type: Boolean,
        required: false,
        default: false,
    },
    primary: {
        type: Boolean,
        required: false,
        default: false,
    },
})

const alignmentClasses = computed(() => {
    if (props.alignment === 'center') {
        return 'text-center'
    } else if (props.alignment === 'right') {
        return 'text-right'
    } else {
        return 'text-left'
    }
})

const hidableClasses = computed(() => {
    return props.hidable ? 'hidden lg:table-cell' : ''
})

const importantClasses = computed(() => {
    return props.important ? 'bg-red-200/25' : ''
})

const primaryClasses = computed(() => {
    return props.primary ? 'font-medium' : ''
})

const displayContent = computed(() => {
    if (
        props.content === '' ||
        props.content === null ||
        props.content === undefined
    ) {
        return '(empty)'
    }

    return props.content
})
</script>
